<div class="np-header" [class.is-charge]="chargeState != ChargeState.None">
  @if (chargeState == ChargeState.None) {
    <div class="np-battery">
      <app-battery [batteryLevel]="estimatedBatteryLevel"></app-battery>
      <span class="np-battery-value">{{ estimatedBatteryLevel }}</span>
      <span class="np-battery-unit">%</span>
    </div>
  }
  @if (chargeState != ChargeState.None) {
    <div class="np-charge-hero">
      <div class="np-charge-hero-icon">
        <img id="charger-icon" alt="charger icon"
        [appSvgRecolor]="'assets/icons/default/ui/charger_icon.svg'"
        [recolorColor]="'#fff'"/>
      </div>
      <div class="np-charge-hero-text">
        @if (heroEyebrow) {
          <span class="np-charge-hero-eyebrow" [class.is-charging]="chargeState == ChargeState.Charging">{{ heroEyebrow }}</span>
        }
        <span class="np-charge-hero-title">{{ chargerName }}</span>
      </div>
    </div>
  }
</div>
